import * as Scrivito from "scrivito";
import defaultPageAttributes from "objs/_defaultPageAttributes";
import metadataAttributes from "objs/_metadataAttributes";

const ContentPage = Scrivito.provideObjClass("ContentPage", {
  attributes: {
    hiddenInNavigation: ["enum", { values: ["Yes", "No"] }],
    keywords: "string",
    metaDescription: "string",
    navigationTitle: "string",
    navigationImage: ["reference", { only: "Image" }],
    slides: ["referencelist", { only: ["TextImageSlide", "TextImage2dSlide"] }],
    seoFooterText: "string",
    body: "html",
    requiresTroxnetLogin: ["enum", { values: ["Yes", "No"] }],
    requiresTroxnetLoginSeminare: ["enum", { values: ["Yes", "No"] }],
    contentWidgets: "widgetlist",
    backgroundImage: ["reference", { only: "Image" }],
    darkBg: ["enum", { values: ["Yes", "No"] }],
    largePaddingsY: ["enum", { values: ["Yes", "No"] }],
    breadCrumbs: ["enum", { values: ["Yes", "No"] }],
    ...defaultPageAttributes,
    ...metadataAttributes,
  },
  extractTextAttributes: ["body", "contentWidgets"],
});

export default ContentPage;
